import React, { useState } from 'react';
import {
    Button,
    Box,
    Typography,
    Alert,
    Checkbox,
    FormControlLabel,
    Paper,
    Fade
} from '@mui/material';
import CustomTextField from './components/Common/CustomTextField';
import { loadConfig, getConfig } from './config';
import api from './services/api'

function Login({ onLoginSuccess }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [rememberMe, setRememberMe] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);

        await loadConfig();

        try {
            let data;
            try {
                const response = await api.post('/login', { username, password });
                data = response.data; // Assuming the API returns JSON data in the `data` field
            } catch (error) {
                console.error('Erro ao carregar os dashboards:', error);
                setError('Erro ao conectar com o servidor');
                setIsLoading(false);
                return;
            }

            if (data.isSuccess) {
                const authData = {
                    usuarioId: data.UsuarioId,
                    usuarioNome: data.UsuarioNome,
                    lastLogin: new Date().toISOString(),
                };

                if (rememberMe) {
                    //Opção para manter o usuário logado guardando os dados no local storage (clicando no lembrar de mim)
                    localStorage.setItem('auth', JSON.stringify(authData));
                } else {
                    //Mantem uma sessão de 2h caso a pessoa não clique no lembrar de mim
                    const expiresAt = new Date();
                    expiresAt.setHours(expiresAt.getHours() + 2);
                    authData.expiresAt = expiresAt.toISOString();
                    localStorage.setItem('auth', JSON.stringify(authData));
                }

                onLoginSuccess(data.UsuarioId, data.UsuarioNome);
            } else {
                setError(data.Message || 'Erro ao realizar login');
            }
        } catch (err) {
            setError('Erro ao conectar com o servidor');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <Fade in={true} timeout={1000}>
                <Box
                    sx={{
                        height: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        background: 'linear-gradient(135deg, #121212 0%, #1d1d1d 100%)',
                    }}
                >
                    <Paper
                        elevation={8}
                        sx={{
                            padding: 4,
                            borderRadius: 2,
                            width: '100%',
                            maxWidth: 400,
                            backgroundColor: 'rgba(29, 29, 29, 0.95)',
                            backdropFilter: 'blur(5px)',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 3,
                            }}
                        >
                            <Box
                                component="img"
                                src="/LogoGNIweb.png"
                                alt="Logo Empresa"
                                sx={{
                                    width: '300px',
                                    height: 'auto',
                                    mb: 2,
                                }}
                            />

                            {error && (
                                <Alert severity="error" sx={{ width: '100%' }}>
                                    {error}
                                </Alert>
                            )}

                            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <CustomTextField
                                        label="Usuário"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                    />

                                    <CustomTextField
                                        label="Senha"
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={rememberMe}
                                                onChange={(e) => setRememberMe(e.target.checked)}
                                                sx={{ color: 'white' }}
                                            />
                                        }
                                        label="Lembrar de mim"
                                        sx={{ color: 'white' }}
                                    />

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        disabled={isLoading}
                                        sx={{
                                            py: 1.5,
                                            fontSize: '1.1rem',
                                            backgroundColor: '#17156BFF',
                                            '&:hover': {
                                                backgroundColor: '#2a2880',
                                            },
                                        }}
                                    >
                                        {isLoading ? 'Entrando...' : 'Entrar'}
                                    </Button>
                                </Box>
                            </form>
                        </Box>
                    </Paper>
                </Box>
            </Fade>
            <Box component="img" src="/LogoEmpresa.png" alt="Logo Tega" sx={{ position: 'absolute', top: 8, left: 8, height: '120px', zIndex: 1000, pointerEvents: 'none' }} />
            <Box component="img" src="/LogoTega.png" alt="Logo Tega" sx={{ position: 'absolute', bottom: 8, right: 8, height: '120px', zIndex: 1000, pointerEvents: 'none' }} />
        </div>
    );
}

    export default Login;